import request from '@/utils/request_cn';

//1.获取汇率兑换列表
export function getPriceUnitList() {
  return request({
    url: "/basic-backend/price/unit/list",
    method: "get",
  });
}

//2.更新汇率
export function updatePriceUnit(data) {
  return request({
    url: `/basic-backend/price/unit/update`,
    method: "POST",
    data
  });
}

export function getWaitEffectTime() {
  return request({
    url: `/basic-backend/price/unit/getWaitEffectTime`,
  });
}

export function updateWaitEffectTime(params) {
  return request({
    url: `/basic-backend/price/unit/updateWaitEffectTime`,
    method: "POST",
    params
  });
}

export function createPriceUnit(data) {
  return request({
    url: `/basic-backend/price/unit/create`,
    method: "POST",
    data
  });
}

export function getListExchangeRate(params) {
  return request({
    url: `/basic-backend/price/unit/listExchangeRate`,
    params,
  });
}

export function getTaxRateList(params) {
  return request({
    url: `/sc-basic-merchant-backend/tax/getTaxRateList`,
    params,
  });
}

export function addTaxRate(data) {
  return request({
    url: `/sc-basic-merchant-backend/tax/addTaxRate`,
    method: "POST",
    data,
  });
}

export function updateTaxRate(data) {
  return request({
    url: `/sc-basic-merchant-backend/tax/updateTaxRate`,
    method: "POST",
    data,
  });
}

export function exportInvoice(data) {
  return request({
    url: `/sc-basic-merchant-backend/vendor/invoice/export/excel`,
    method: "POST",
    data,
  });
}
